import Bugsnag from '@bugsnag/js';
import errorBuilder from './errorBuilder.js';

export default function (messageService) {
  const buildArgument = (error) => {
    const response = error.response || {};
    const request = error.request || {};
    return {
      status: 'ERROR',
      payload: {
        statusCode: response.status,
        requestUrl: request.url,
        responseData: response.data,
        errorMessage: error.message
      }
    };
  };

  return (error, report = true) => {
    if (report) {
      Bugsnag.notify(error);
    }
    let err = {};
    if (error.response) {
      messageService.post(buildArgument(error));
      // The service responded with a status code outside 2xx
      err = errorBuilder(error.response);
    } else if (error.request) {
      // The request has been made but no response has been received
      const requestedUrl = error.request.url;
      err.message = `cannot get any response from ${requestedUrl}`;
    } else {
      // Hasn't been possible to make the request
      err.message = `Error ${error.message}`;
    }

    return err;
  };
}
